import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import AddVAT from './AddVAT';
import Update from './Update';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { GetTaxManagersList } from '@store/Finance/TaxManagers/TaxManagerSlice';
import ModalComponent from '@components/Modal/ModalComponent';
import { type CashTransferModels } from '@store/Finance/TaxManagers/TaxManagerModels';
import NtxTable from '@components/DataTable/NtxTable';
import Loading from '@components/Shared/Loader/Loading';

const Index = () => {
  const [Show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const [vatDetiles, setVatDetiles] = useState<CashTransferModels>();

  const { TaxManagerList, loading, error } = useAppSelector(a => a.TaxManager);
  useEffect(() => {
    if (TaxManagerList?.length === 0) {
      dispatch(GetTaxManagersList());
    }
  }, []);

  const columns = [
    { title: t('TaxType'), key: 'type' },
    { title: t('TaxRate'), key: 'pres' },
    { title: t('FromDate'), key: 'from' },
    { title: t('ToDate'), key: 'to' },
    { title: t('Account'), key: 'acc' },
    // { title: t('GeneralLedger'), key: 'led' },

    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = TaxManagerList?.map(item => {
    let rowClass;

    return {
      type: item.taxType,
      pres: item.taxRate,
      from: item.startDateActive?.toString()?.split('T')[0],
      to: item.endDateActive?.toString()?.split('T')[0],
      acc: i18n.language === 'en' ? item.accountName : item.accountName,
      // led: i18n.language === 'en' ? item.ledgerName : item.ledgerName2,

      action: (
        <></>
        // <button
        //   type='button'
        //   className='btn btn-sm btn-outline-theme'
        //   data-bs-toggle='modal'
        //   data-bs-target='#modalEditVat'
        //   onClick={() => {
        //     setVatDetiles(item);
        //     setShow(true);
        //   }}
        // >
        //   <i className='far fa-lg fa-fw me-2 fa-edit'></i>
        //   {t('Button.Edit')}
        // </button>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  //____________________________
  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'Tax',
              link: null
            }
          ]}
          PageName='Tax'
        />

        {/* <div className='ms-auto'>
          <Link
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddVat'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1 p-1'></i>
            {t('AddNewTax')}
          </Link>
        </div> */}
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddNewTax')} id='modalAddVat' size='md'>
        {Show && <AddVAT />}
      </ModalComponent>
      <ModalComponent title={t('EditTax')} id='modalEditVat' size='md'>
        {Show && <Update data={vatDetiles} />}
      </ModalComponent>
    </div>
  );
};

export default Index;

// import React, { useEffect, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import ModalComponent from '@components/Modal/ModalComponent';
// import AddVAT from './AddVAT';
// import Update from './Update';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { GetTaxManagersList } from '@store/Finance/TaxManagers/TaxManagerSlice';
// import { type TaxManagerModels } from '@store/Finance/TaxManagers/TaxManagerModels';
// import Loading from '@components/Shared/Loader/Loading';
// import Pagination from '@components/Shared/Pagination/Pagination';

// const Index = () => {
//   const [Show, setShow] = useState<boolean>(false);
//   const [editData, setEditData] = useState<TaxManagerModels | null>(null);
//   const [searchTerm, setSearchTerm] = useState<string>('');
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [dataPerPage, setDataPerPage] = useState<number>(10);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   const { TaxManagerList, loading, error } = useAppSelector(a => a.TaxManager);

//   useEffect(() => {
//     if (TaxManagerList?.length === 0) {
//       dispatch(GetTaxManagersList());
//     }
//   }, [dispatch, TaxManagerList]);

//   // إحصائيات الضرائب
//   const totalTaxes = TaxManagerList?.length || 0;
//   const activeTaxes = TaxManagerList?.filter((tax: TaxManagerModels) => {
//     const today = new Date();
//     const endDate = tax.endDateActive ? new Date(tax.endDateActive) : null;
//     return !endDate || endDate > today;
//   }).length || 0;
//   const expiredTaxes = totalTaxes - activeTaxes;

//   // دالة مسح البحث
//   const clearSearch = (): void => {
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   // الحصول على البيانات المعروضة بناءً على اللغة
//   const getDisplayText = (enText: string, arText: string | undefined): string => {
//     return i18n.language === 'en' ? enText : arText || enText;
//   };

//   // تصفية البيانات حسب البحث
//   const filteredTaxList = TaxManagerList?.filter((item: TaxManagerModels) => {
//     if (searchTerm.trim() === '') return true;

//     const searchLower = searchTerm.toLowerCase();
//     const type = (item.taxType || '').toLowerCase();
//     const account = getDisplayText(item.accountName || '', item.accountName).toLowerCase();
//     const rate = (item.taxRate?.toString() || '').toLowerCase();

//     return type.includes(searchLower) || account.includes(searchLower) || rate.includes(searchLower);
//   }) || [];

//   // الحصول على البيانات للصفحة الحالية
//   const indexOfLastItem = currentPage * dataPerPage;
//   const indexOfFirstItem = indexOfLastItem - dataPerPage;
//   const currentTaxList = filteredTaxList.slice(indexOfFirstItem, indexOfLastItem);

//   // دالة تغيير الصفحة
//   const handlePagination = (pageNumber: number) => {
//     setCurrentPage(pageNumber);
//   };

//   // دالة تغيير عدد العناصر المعروضة في الصفحة
//   const handleDataPerPageChange = (newDataPerPage: number) => {
//     setDataPerPage(newDataPerPage);
//     setCurrentPage(1);
//   };

//   // الحصول على بادجة حالة الضريبة
//   const getTaxStatusBadge = (tax: TaxManagerModels) => {
//     const today = new Date();
//     const endDate = tax.endDateActive ? new Date(tax.endDateActive) : null;
//     const isActive = !endDate || endDate > today;

//     const badgeClass = isActive ? 'bg-success text-white' : 'bg-danger text-white';
//     const badgeText = isActive ? t('Active') : t('Expired');

//     return (
//       <span
//         className={`badge d-block rounded px-2 py-1 text-wrap text-center fw-bold ${badgeClass}`}
//         style={{ minWidth: '80px', maxWidth: '120px', display: 'inline-block' }}
//       >
//         {badgeText}
//       </span>
//     );
//   };

//   // الحصول على نوع الضريبة مع أيقونة
//   const getTaxTypeWithIcon = (type: string) => {
//     let icon = 'fa-percentage';
//     let color = 'text-primary';

//     switch(type?.toLowerCase()) {
//       case 'vat':
//         icon = 'fa-receipt';
//         color = 'text-success';
//         break;
//       case 'sales':
//         icon = 'fa-shopping-cart';
//         color = 'text-info';
//         break;
//       case 'income':
//         icon = 'fa-money-bill-wave';
//         color = 'text-warning';
//         break;
//       default:
//         icon = 'fa-percentage';
//         color = 'text-primary';
//     }

//     return (
//       <div className='d-flex align-items-center'>
//         <i className={`fas ${icon} fa-fw me-2 ${color}`}></i>
//         <span>{type}</span>
//       </div>
//     );
//   };

//   const breadcrumbList = [
//     {
//       name: 'Home',
//       link: ':moduleHome'
//     },
//     {
//       name: 'Tax',
//       link: null
//     }
//   ];

//   return (
//     <Loading loading={loading} error={error}>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={breadcrumbList}
//           PageName={t('TaxManagement')}
//         />

//         <div className='ms-auto'>
//           <Link
//             to=''
//             className='btn me-1 btn-theme'
//             data-bs-toggle='modal'
//             data-bs-target='#modalAddVat'
//             onClick={() => setShow(true)}
//           >
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('AddNewTax')}
//           </Link>
//         </div>
//       </div>

//       {/* بطاقات الإحصائيات */}
//       <div className='row mb-4'>
//         {/* إجمالي الضرائب */}
//         <div className='col-md-4'>
//           <Card className='bg-primary bg-opacity-10 border-primary border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fa fa-percentage fa-2x text-primary'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-primary mb-0'>{totalTaxes}</h4>
//                   <p className='text-muted mb-0'>إجمالي الضرائب</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         {/* الضرائب النشطة */}
//         <div className='col-md-4'>
//           <Card className='bg-success bg-opacity-10 border-success border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fa fa-check-circle fa-2x text-success'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-success mb-0'>{activeTaxes}</h4>
//                   <p className='text-muted mb-0'>الضرائب النشطة</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>

//         {/* الضرائب المنتهية */}
//         <div className='col-md-4'>
//           <Card className='bg-danger bg-opacity-10 border-danger border-0 shadow-sm h-100'>
//             <CardBody className='py-3'>
//               <div className='d-flex align-items-center'>
//                 <div className='flex-shrink-0'>
//                   <i className='fa fa-times-circle fa-2x text-danger'></i>
//                 </div>
//                 <div className='flex-grow-1 ms-3'>
//                   <h4 className='text-danger mb-0'>{expiredTaxes}</h4>
//                   <p className='text-muted mb-0'>الضرائب المنتهية</p>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <div className='card-header d-flex justify-content-between align-items-center'>
//           <h6 className='mb-0'>
//             <i className='fas fa-percentage me-2'></i>
//             سجل الضرائب
//           </h6>

//           {/* شريط البحث وعدد العناصر */}
//           <div className='d-flex align-items-center'>
//             {/* اختيار عدد العناصر المعروضة */}
//             <div className='me-3'>
//               <select
//                 className='form-select form-select-sm'
//                 value={dataPerPage}
//                 onChange={(e) => handleDataPerPageChange(Number(e.target.value))}
//               >
//                 <option value={5}>5</option>
//                 <option value={10}>10</option>
//                 <option value={25}>25</option>
//                 <option value={50}>50</option>
//                 <option value={100}>100</option>
//               </select>
//             </div>

//             {/* شريط البحث */}
//             <div className='input-group input-group-sm' style={{ width: '300px' }}>
//               <span className='input-group-text'>
//                 <i className='fas fa-search text-muted'></i>
//               </span>
//               <input
//                 type='text'
//                 className='form-control border-start-0'
//                 placeholder='ابحث بنوع الضريبة أو الحساب أو النسبة...'
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setCurrentPage(1);
//                 }}
//               />
//               {searchTerm && (
//                 <button
//                   className='btn btn-outline-secondary'
//                   type='button'
//                   onClick={clearSearch}
//                   title='مسح البحث'
//                 >
//                   <i className='fas fa-times'></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className='card-body p-0'>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='table-actived fw-bold'>
//                 <tr>
//                   <th className='small'>نوع الضريبة</th>
//                   <th className='small'>نسبة الضريبة</th>
//                   <th className='small'>تاريخ البدء</th>
//                   <th className='small'>تاريخ الانتهاء</th>
//                   <th className='small'>الحساب</th>
//                   <th className='small'>الحالة</th>
//                   <th className='small'>الإجراءات</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentTaxList.length > 0 ? (
//                   currentTaxList.map((item: TaxManagerModels) => (
//                     <tr key={item.id}>
//                       <td className='align-middle'>
//                         {getTaxTypeWithIcon(item.taxType || '')}
//                       </td>
//                       <td className='align-middle'>
//                         <span className='badge bg-info'>
//                           {item.taxRate}%
//                         </span>
//                       </td>
//                       <td className='align-middle'>
//                         <span className='text-muted'>
//                           {item.startDateActive?.toString()?.split('T')[0] || '---'}
//                         </span>
//                       </td>
//                       <td className='align-middle'>
//                         <span className='text-muted'>
//                           {item.endDateActive?.toString()?.split('T')[0] || 'لا نهاية'}
//                         </span>
//                       </td>
//                       <td className='align-middle'>
//                         <span className='badge bg-secondary'>
//                           {getDisplayText(item.accountName || '', item.accountName)}
//                         </span>
//                       </td>
//                       <td className='align-middle'>
//                         {getTaxStatusBadge(item)}
//                       </td>
//                       <td className='align-middle'>
//                         <button
//                           type='button'
//                           className='btn btn-sm btn-outline-theme'
//                           data-bs-toggle='modal'
//                           data-bs-target='#modalEditVat'
//                           onClick={() => {
//                             setEditData(item);
//                             setShow(true);
//                           }}
//                         >
//                           <i className='far fa-edit fa-fw me-1'></i>
//                           {t('Button.Edit')}
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan={7} className='text-center py-4 text-muted'>
//                       <i className='fa fa-percentage fa-2x mb-2'></i>
//                       <br />
//                       {searchTerm ? 'لا توجد نتائج للبحث' : 'لا توجد ضرائب مسجلة'}
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         <div className='card-footer'>
//           <Pagination
//             filteredData={filteredTaxList}
//             dataPerPage={dataPerPage}
//             handlePagination={handlePagination}
//             currentPage={currentPage}
//           />
//         </div>
//       </Card>

//       <ModalComponent title={t('AddNewTax')} id='modalAddVat' size='md'>
//         {Show && <AddVAT onClose={() => setShow(false)} />}
//       </ModalComponent>

//       <ModalComponent title={t('EditTax')} id='modalEditVat' size='md'>
//         {Show && editData && <Update data={editData} onClose={() => setShow(false)} />}
//       </ModalComponent>
//     </Loading>
//   );
// };

// export default Index;
